import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
  getBankFields() {
    return {model: 'requests_bank', 
            label: 'Banks',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
            ]}
  },
}

export const actions = {
  async fetchBanks(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/banks/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createBanks(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/banks/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateBanks(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/banks/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteBanks(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/banks/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}